import { Navigate, type RouteObject } from 'react-router-dom';

import { Scopes } from '../../../api/types';
import { RouteGuard } from '../../../components/RouteGuard';
import { DiscoveryAnalyzingStep } from './pages/DiscoveryAnalyzingStep';
import { DiscoveryMaturityStep } from './pages/DiscoveryMaturityStep';
import { DiscoveryPublishStep } from './pages/DiscoveryPublishStep';
import { DiscoveryReviewStep } from './pages/DiscoveryReviewStep';
import { DiscoveryUploadStep } from './pages/DiscoveryUploadStep';
import { DiscoveryWizard } from './pages/DiscoveryWizard';
import { RecommendationsPage } from './pages/RecommendationsPage';

/**
 * Routes contributed by the Discovery feature (Phase 6 Wave 11.F).
 *
 * Mounted under the authenticated layout in `src/routes.tsx`. Every step
 * requires SchemasRead; the final `publish` step demands SchemasWrite since
 * it mutates the catalogue irreversibly.
 */
export const discoveryRoutes: RouteObject[] = [
  {
    path: 'document-types/discover',
    element: (
      <RouteGuard scope={Scopes.SchemasRead}>
        <DiscoveryWizard />
      </RouteGuard>
    ),
    children: [
      { index: true, element: <Navigate to="upload" replace /> },
      { path: 'upload', element: <DiscoveryUploadStep /> },
      { path: ':draftId/upload', element: <DiscoveryUploadStep /> },
      { path: ':draftId/analyzing', element: <DiscoveryAnalyzingStep /> },
      { path: ':draftId/review', element: <DiscoveryReviewStep /> },
      { path: ':draftId/maturity', element: <DiscoveryMaturityStep /> },
      {
        path: ':draftId/publish',
        element: (
          <RouteGuard scope={Scopes.SchemasWrite}>
            <DiscoveryPublishStep />
          </RouteGuard>
        ),
      },
    ],
  },
  {
    path: 'document-types/:slug/recommendations',
    element: (
      <RouteGuard scope={Scopes.SchemasRead}>
        <RecommendationsPage />
      </RouteGuard>
    ),
  },
];
